import {
  ALLOWED_DOMAINS,
  FALLBACK_CDN_PACKAGES,
  FALLBACK_IMPORT_MAP,
  PRIMARY_CDN_PACKAGES,
  PRIMARY_IMPORT_MAP,
} from "../constants";
import { LocalStorageWrapper } from "../helper/localStorageWrapper";
import { renderMountErrorMessage } from "../helper/utils";

const storage = new LocalStorageWrapper();

let trustedTypesPolicy = null;

if (
  typeof window.trustedTypes !== "undefined" &&
  window.trustedTypes.createPolicy
) {
  try {
    trustedTypesPolicy = window.trustedTypes.createPolicy(
      "ottu-script-loader",
      {
        createScript: (input) => input,
        createScriptURL: (url) => {
          const isAllowed = ALLOWED_DOMAINS.some((domain) =>
            url.startsWith(domain)
          );

          if (!isAllowed) {
            throw new Error(`Untrusted script URL: ${url}`);
          }

          return url;
        },
      }
    );
  } catch (e) {
    console.warn("Failed to create Trusted Types policy:", e);
  }
}

async function loadScripts(importMap, packageUrls) {
  const importMapScript = document.createElement("script");
  importMapScript.type = "systemjs-importmap";

  const importMapContent = JSON.stringify(importMap, null, 2);

  if (trustedTypesPolicy) {
    importMapScript.textContent =
      trustedTypesPolicy.createScript(importMapContent);
  } else {
    importMapScript.textContent = importMapContent;
  }

  document.head.appendChild(importMapScript);

  const scriptPromises = packageUrls.map((packageInfo) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");

      if (trustedTypesPolicy) {
        try {
          script.src = trustedTypesPolicy.createScriptURL(packageInfo.url);
        } catch (e) {
          console.error(
            "Trusted Types validation failed for URL:",
            packageInfo.url,
            e
          );
          reject(e);
          return;
        }
      } else {
        script.src = packageInfo.url;
      }

      script.integrity = packageInfo.integrity;
      script.crossOrigin = "anonymous";
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  });

  await Promise.all(scriptPromises);

  try {
    // eslint-disable-next-line no-undef
    await System.import("@ottu-mf/root-config");
    storage.removeItem("SINGLE_SPA_MOUNT_ATTEMPTS");
  } catch (err) {
    console.log(err);
    const numberOfAttempts = storage.getItem("SINGLE_SPA_MOUNT_ATTEMPTS");

    const hasExceededRetryLimit = Number(numberOfAttempts) >= 3;
    if (!hasExceededRetryLimit) {
      storage.setItem(
        "SINGLE_SPA_MOUNT_ATTEMPTS",
        Number(numberOfAttempts) + 1
      );
      window.location.reload();
    } else {
      renderMountErrorMessage();
      storage.removeItem("SINGLE_SPA_MOUNT_ATTEMPTS");
    }
  }
}

async function initializeScripts() {
  try {
    await loadScripts(PRIMARY_IMPORT_MAP, PRIMARY_CDN_PACKAGES);
  } catch (err) {
    console.log(err);
    loadScripts(FALLBACK_IMPORT_MAP, FALLBACK_CDN_PACKAGES);
  }
}

initializeScripts();
